import { createSelector } from 'reselect';
import { SupportedSystems, EMPTY_ARRAY } from '../../shared';
import { selectCurrentSystem, selectProjectEntryData } from '../ProjectEntry/selectors';

const allLrsProceduresForUser = createSelector(
  selectProjectEntryData,
  projectEntries => {
    return projectEntries
      .filter(pe => pe.type === SupportedSystems.LRS)
      .reduce((acc, project) => {
        return (acc.push(...project.procedures), acc);
      }, []);
  }
);
  
const selectLrsProjects = state => state.projects.lrs.projects;
const selectVpinProjects = state => state.projects.vpin.projects;
const projectsForCurrentSystem = createSelector(
  [selectLrsProjects, selectVpinProjects, selectCurrentSystem],
  (lrsProjects, vpinProjects, currentSystem) => {
    switch (currentSystem) {
      case SupportedSystems.LRS:
        return lrsProjects;
      case SupportedSystems.VPIN:
        return vpinProjects;
      default:
        return EMPTY_ARRAY;
    }
  }
)
const selectVpinProjectsForUser = createSelector(
  selectProjectEntryData,
  data => data.filter(q => q.type === SupportedSystems.VPIN)
);
const filteredProjects = createSelector(
  [projectsForCurrentSystem, selectVpinProjectsForUser, selectCurrentSystem],
  (projects, vpinProjectsForUser, currentSystem) => {
    if (currentSystem !== SupportedSystems.VPIN)
      return projects;

    return projects.filter(q => !vpinProjectsForUser.find(v => v.projectNumber === q.projectNumber));
  }
)

export const selectors = {
  projectsForCurrentSystem,
  allLrsProceduresForUser,
  filteredProjects,
};